export default __webpack_public_path__ + "static/media/mobile.13a3e547.svg";